export default {
  isLoading: false,
  error: null,
  shipmentTemplates: [],
  bulkTemplates: {},
  dealTemplates: [],
};
